module.exports = __webpack_public_path__ + "static/media/Духновский С.А..ae7a89b8.pdf";